<script>
    import DeliveryAddressApi from '../delivery-address-api';

    export default {
        props: {
         
        },
        data: function () {
            return {
                isLoading: false,
                selected: '',
                currentAddress: '',
                enableDeleteDropdown: this.$currentDeliveryAddressDeleteActive,
                showGln() {
                    return jQuery("body.customer-business").length > 0;
                },
                addressList: [],
                currentTarget: this.$currentDeliveryAddressTargetSelector,
                deleteTarget: this.$currentDeliveryAddressDeleteTargetSelector,
                isPreview: this.$currentDeliveryAddressIsPreview,
                isReadOnly: this.$currentDeliveryAddressIsReadOnly
            } 
        },
       
        mounted: function () {
            this.loadAddresses();
            var loadMethod = this.loadAddresses;
            var me = this;
            PubSub.subscribe("DeliveryAddress.NewAddressAdded", function (event, data) {
                if (data.id > 0) {
                    me.selected = data.id;
                    DeliveryAddressApi.setSelectedDeliveryAddress(data.id)
                        .then(() => {
                            loadMethod().then(() => {
                                me.publishCurrentZipCode();
                            });
                        });
                }
                else loadMethod();
            });
        },
        beforeUnmount: function () {
            PubSub.unsubscribe("DeliveryAddress.NewAddressAdded");
        },
        methods: {
            loadAddresses: async function() {
                this.isLoading = true;

                try {
                    const currentDeliveryAddress = await DeliveryAddressApi.getCurrentDeliveryAddress();
                    if (!currentDeliveryAddress.data.Success){
                        return;
                    }

                    this.currentAddress = currentDeliveryAddress.data.DeliveryAddress;
                    this.selected = this.currentAddress.EkstraLeveringsAdresseId;

                    const listDeliveryAddresses = await DeliveryAddressApi.listDeliveryAddresses();
                    if (!listDeliveryAddresses.data.Success) return;

                    this.addressList = listDeliveryAddresses.data.DeliveryAddresses;
                } catch(error) {
                    console.log(error);
                } finally {
                    this.isLoading = false;
                }
            },
            close: function () {
            },

            clickNewDeliveryAddress: function (data, event) {
                PubSub.publish("DeliveryAddress.ShowCreateNew");
            },
            clickRemoveDeliveryAddress: function (event) {
                if (confirm(this.$t("DeliveryAddress.ConfirmRemoveDeliveryAddress"))) {
                    DeliveryAddressApi.removeDeliveryAddress(this.currentAddress.EkstraLeveringsAdresseId)
                        .then((result) => {
                            this.$toast.success(this.$t('DeliveryAddress.AddressWasRemoved'));
                            this.loadAddresses().then(() => {
                                DeliveryAddressApi.setSelectedDeliveryAddress(this.selected);
                                this.publishCurrentZipCode();
                            });
                            
                        });
                    
                }
            },
            change: function () {
                if (this.selected === 0)
                    return;

                this.currentAddress = this.addressList.find(address => address.EkstraLeveringsAdresseId === this.selected)
                DeliveryAddressApi.setSelectedDeliveryAddress(this.selected);
                this.publishCurrentZipCode();
            },

            publishCurrentZipCode: function () {
                var data = { zipCode: this.currentAddress.PostCode };
                PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                PubSub.publish("DeliveryAddress.ChangedSelectedDeliveryAddress", this.selected <= 0);
            }

        },
        computed: {
            isDefaultAddressSelected () {
                return this.selected === '' || this.selected < 0;
            },
            previewClass() {
                if (this.isPreview)
                    return '';
                return 'preview-adr';
            },
            readOnly() {
                return this.isReadOnly;
            }
            ,
            selectedAddress() {
                return {

                }
            }

        }


    };

</script>
<template>
    <teleport :to="deleteTarget" :disabled="isPreview">
        <div class="col-xs-12 col-sm-6 delivery-address-picker">
            <select v-model="selected" @change="change">
                <option v-for="option in addressList" :value="option.EkstraLeveringsAdresseId">
                    {{option.Name}} - {{option.City}} - {{option.PostCode}} - {{option.Address1}}
                </option>

            </select>
        </div>
        <div class="col-xs-12 col-sm-6 delivery-address-buttons">       
            <button type="button" class="btn left" v-show="!isReadOnly" @click="clickNewDeliveryAddress">{{$t("DeliveryAddress.NewDeliveryAddress")}}</button>
            <button type="button" v-show="!isDefaultAddressSelected &&  !readOnly" class="btn right" @click="clickRemoveDeliveryAddress">{{$t("DeliveryAddress.RemoveDeliveryAddress")}}</button>
        </div>
        <div class="center-block"  v-if="isLoading">
            <i class="icon-spinner animate-spin"></i>
        </div>
    </teleport>
    <teleport :to="currentTarget" :disabled="isDefaultAddressSelected" v-if="!isDefaultAddressSelected">
        
        <fieldset :class="previewClass">
            <legend class="preview-delivery-title">
                {{
$t('CHECKOUT.PreviewShippingAddress')
                }}
            </legend>
            <div class="preview-delivery-right col-xs-12 col-sm-6">
                <div class="center-block" v-if="isLoading">
                    <i class="icon-spinner animate-spin"></i>
                </div>
                <ul class="preview-list" v-if="currentAddress !== null">
                    <li class="preview-delivery-name">{{currentAddress.Name}}</li>
                    <li class="preview-delivery-address">{{currentAddress.Address1}}</li>
                    <li class="preview-delivery-adresstilleg" v-if="currentAddress.Address2 != null && currentAddress.Address2.length > 0">{{currentAddress.Address2}}</li>
                    <li class="preview-delivery-adresstilleg" v-if="currentAddress.Address3 != null && currentAddress.Address3.length > 0">{{currentAddress.Address3}}</li>
                    <li class="preview-delivery-post">
                        <span class="preview-delivery-zip">{{currentAddress.PostCode}}</span>
                        <span class="preview-delivery-city">{{currentAddress.City}}</span>
                    </li>
                    <li class="preview-delivery-gln" v-if="currentAddress.GLN != null && currentAddress.GLN.length > 0 && showGln()">{{currentAddress.GLN}}</li>
                    <li class="preview-delivery-country" v-if="currentAddress.Country != null && currentAddress.Country.length > 0">{{currentAddress.Country}}</li>
                    <li class="preview-delivery-contact" v-if="currentAddress.Attention != null && currentAddress.Attention.length > 0">{{currentAddress.Attention}}</li>
                    <li class="preview-delivery-phone" v-if="currentAddress.MobilePhone != null && currentAddress.MobilePhone.length >0">{{currentAddress.MobilePhone}}</li>
                    <li class="preview-delivery-phone" v-if="currentAddress.PhoneNumber != null && currentAddress.PhoneNumber.length > 0">{{currentAddress.PhoneNumber}}</li>
                    <li class="preview-delivery-email" v-if="currentAddress.Email != null && currentAddress.Email.length > 0">{{currentAddress.Email}}</li>
                </ul>                
            </div>
        </fieldset>
    </teleport>
</template>

<style lang="scss">
    .customer-registration {
        & .preview-list {
            & .preview-delivery-email:before {
                content: "\f0e0";
            }
        }

        & #vue-current-delivery-info .preview-adr {
            margin: 1.2em;
        }

        & .preview-adr .preview-delivery-zip {
                margin-right: 0.5em;
            }

        & #delivery-address-delete-info-placeholder {
            margin-top: 10px;

            & .delivery-address-picker {
                margin-top: 10px;
            }

            & .delivery-address-buttons {
                margin-top: 10px;
            }

            & .col-sm-6.delivery-address-picker {
                padding-right: 0px;

                @media (max-width: 767px) {
                    padding-right: 15px;
                }
            }

            & select {
                width: 100%;
                height: 34px;
                padding-left: 10px;
            }

            & button {
                width: calc(50% - 10px);

                &.left {
                    float: left;
                }

                &.right {
                    float: right;
                    margin-right: 0px;
                }
            }

            @media (min-width: 768px) {

                & button {
                    margin-right: 15px;
                }
            }

            @media (max-width: 767px) {
                & select {
                    margin-bottom: 15px;
                }
            }
        }
    }
</style>